import { ShipmentService } from "../services/ShipmentService";
import { ContainerService } from "../services/ContainerService";

export class LogitudeObjectDetails {

    private shipmentService = new ShipmentService();
    private containerService = new ContainerService();

    getObjectDetails = async (entity: string, entityNumber: string): Promise<any> => {
        switch (entity.toLowerCase()) {
            case "shipment": return this.shipmentService.getShipmentByEntityNumber(entityNumber);
            case "container": return this.containerService.getContainerById(entityNumber);
        }
    }
}